module.exports = __webpack_public_path__ + "5deaecca5406a9fb03a34c1a39a9f7b7.png";